import { gql } from "@apollo/client";
import { print } from "graphql";

export const FILTERS_QUERY = print(gql`
  query FilterOptionsCourses($categorySlug: String) {
    filterOptionsCourses(categorySlug: $categorySlug) {
      subcategories {
        slug
        name
      }
      modalities {
        id
        name
      }
      educationalUnits {
        id
        visibleName
        state
      }
      states
      teachingAreas {
        id
        name
      }
      partners {
        id
        visibleName
      }
    }
  }
`);

export interface Filters {
  subcategories: Array<{
    slug: string;
    name: string;
  }>;
  modalities: Array<{
    name: string;
    id: number;
  }>;
  educationalUnits: Array<{
    id: number;
    visibleName: string;
    state: string;
  }>;
  states: string[];
  teachingAreas: Array<{
    name: string;
    id: number;
  }>;
  partners: Array<{
    visibleName: string;
    id: number;
  }>;
}
